export default "__VITE_ASSET__BpXp58wb__"